import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link, withRouter } from 'react-router-dom';

import logo from './org-web.svg';

import './stylesheet.css';

import * as baseActions from '../../actions/base';
import { ActionCreators as undoActions } from 'redux-linear-undo';

import { List } from 'immutable';
import _ from 'lodash';
import classNames from 'classnames';

class HeaderBar extends PureComponent {
  constructor(props) {
    super(props);

    _.bindAll(this, [
      'handleChangelogClick',
      'handleSettingsClick',
      'handleModalPageDoneClick',
      'handleSettingsSubPageBackClick',
      'handleUndoClick',
      'handleHelpClick',
    ]);
  }

  getPathRoot() {
    const {
      location: { pathname },
    } = this.props;
    return pathname.split('/')[1];
  }

  renderFileBrowserBackButton() {
    const {
      location: { pathname },
      syncBackendType,
    } = this.props;
    if (syncBackendType === 'Google Drive') {
      return <div />;
    }

    let directoryPath = pathname.substr('/files'.length);
    if (directoryPath.endsWith('/')) {
      directoryPath = directoryPath.substring(0, directoryPath.length - 1);
    }

    if (directoryPath === '') {
      return <div />;
    } else {
      const pathParts = directoryPath.split('/');
      const parentDirectoryName = pathParts[pathParts.length - 2];
      const parentPath = pathParts.slice(0, pathParts.length - 1).join('/');

      return (
        <Link to={`/files${parentPath}`} className="header-bar__back-button">
          <i className="fas fa-chevron-left" />
          <span className="header-bar__back-button__directory-path">{parentDirectoryName}/</span>
        </Link>
      );
    }
  }

  renderOrgFileBackButton() {
    const {
      location: { pathname },
    } = this.props;

    let filePath = pathname.substr('/file'.length);
    if (filePath.endsWith('/')) {
      filePath = filePath.substring(0, filePath.length - 1);
    }

    const pathParts = filePath.split('/');
    const directoryPath = pathParts.slice(0, pathParts.length - 1).join('/');

    return (
      <Link to={`/files${directoryPath}`} className="header-bar__back-button">
        <i className="fas fa-chevron-left" />
        <span className="header-bar__back-button__directory-path">File browser</span>
      </Link>
    );
  }

  renderLogo() {
    return (
      <div className="header-bar__logo-container">
        <img className="header-bar__logo" src={logo} alt="Logo" width="30" height="30" />
        <h2 className="header-bar__app-name">org-web</h2>
      </div>
    );
  }

  renderSampleFileBackButton() {
    return (
      <Link to={`/`} className="header-bar__back-button">
        <i className="fas fa-chevron-left" />
        <span className="header-bar__back-button__directory-path">Home</span>
      </Link>
    );
  }

  renderSignInBackButton() {
    return (
      <Link to={`/`} className="header-bar__back-button">
        <i className="fas fa-chevron-left" />
        <span className="header-bar__back-button__directory-path">Home</span>
      </Link>
    );
  }

  handleSettingsSubPageBackClick() {
    this.props.base.popModalPage();
  }

  renderSettingsSubPageBackButton() {
    return (
      <div className="header-bar__back-button" onClick={this.handleSettingsSubPageBackClick}>
        <i className="fas fa-chevron-left" />
        <span className="header-bar__back-button__directory-path">Settings</span>
      </div>
    );
  }

  renderBackButton() {
    const { activeModalPage } = this.props;

    switch (activeModalPage) {
      case 'changelog':
        return this.renderSettingsSubPageBackButton();
      case 'keyboard_shortcuts_editor':
        return this.renderSettingsSubPageBackButton();
      case 'capture_templates_editor':
        return this.renderSettingsSubPageBackButton();
      case 'sample':
        return this.renderSettingsSubPageBackButton();
      case 'settings':
        return <div />;
      default:
    }

    switch (this.getPathRoot()) {
      case '':
        return this.renderLogo();
      case 'files':
        return this.renderFileBrowserBackButton();
      case 'file':
        return this.renderOrgFileBackButton();
      case 'sample':
        return this.renderSampleFileBackButton();
      case 'sign_in':
        return this.renderSignInBackButton();
      default:
        return <div />;
    }
  }

  renderTitle() {
    const titleContainerWithText = text => <div className="header-bar__title">{text}</div>;

    switch (this.props.activeModalPage) {
      case 'changelog':
        return titleContainerWithText('Changelog');
      case 'settings':
        return titleContainerWithText('Settings');
      case 'keyboard_shortcuts_editor':
        return titleContainerWithText('Shortcuts');
      case 'capture_templates_editor':
        return titleContainerWithText('Capture');
      case 'sample':
        return titleContainerWithText('Sample');
      default:
    }

    switch (this.getPathRoot()) {
      case 'sample':
        return titleContainerWithText('Sample');
      case 'sign_in':
        return titleContainerWithText('Sign in');
      default:
    }

    return titleContainerWithText('');
  }

  handleChangelogClick() {
    this.props.base.pushModalPage('changelog');
  }

  handleSettingsClick() {
    this.props.base.pushModalPage('settings');
  }

  handleModalPageDoneClick() {
    this.props.base.clearModalStack();
  }

  handleUndoClick() {
    if (this.props.isUndoEnabled) {
      this.props.undo.undo();
    }
  }

  handleHelpClick() {
    this.props.base.pushModalPage('settings');
    this.props.base.pushModalPage('sample');
  }

  renderActions() {
    const {
      isAuthenticated,
      hasUnseenChangelog,
      activeModalPage,
      path,
      isUndoEnabled,
    } = this.props;

    if (!!activeModalPage) {
      return (
        <div className="header-bar__actions" onClick={this.handleModalPageDoneClick}>
          Done
        </div>
      );
    } else {
      const undoIconClassName = classNames('fas fa-undo header-bar__actions__item', {
        'header-bar__actions__item--disabled': !isUndoEnabled,
      });

      const settingsIconClassName = classNames('fas fa-cogs header-bar__actions__item', {
        'settings-icon--has-unseen-changelog': hasUnseenChangelog,
      });

      return (
        <div className="header-bar__actions">
          {!isAuthenticated &&
            this.getPathRoot() !== 'sign_in' && (
              <Link to="/sign_in">
                <div className="header-bar__actions__item" title="Sign in">
                  Sign in
                </div>
              </Link>
            )}

          {!isAuthenticated && (
            <a href="https://github.com/DanielDe/org-web" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github header-bar__actions__item" />
            </a>
          )}

          {isAuthenticated &&
            !activeModalPage &&
            !!path && (
              <Fragment>
                <i className={undoIconClassName} onClick={this.handleUndoClick} title="Undo" />
                <i
                  className="fas fa-question-circle header-bar__actions__item"
                  onClick={this.handleHelpClick}
                  title="Help"
                />
              </Fragment>
            )}

          {isAuthenticated && (
            <i
              className={settingsIconClassName}
              onClick={this.handleSettingsClick}
              title="Settings"
            />
          )}
        </div>
      );
    }
  }

  render() {
    const className = classNames('header-bar', {
      'header-bar--with-logo': this.getPathRoot() === '',
    });

    return (
      <div className={className}>
        {this.renderBackButton()}
        {this.renderTitle()}
        {this.renderActions()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isAuthenticated: state.syncBackend.get('isAuthenticated'),
    hasUnseenChangelog: state.base.get('hasUnseenChangelog'),
    activeModalPage: state.base.get('modalPageStack', List()).last(),
    path: state.org.present.get('path'),
    isUndoEnabled: state.org.past.length > 0,
    syncBackendType: state.syncBackend.get('client') && state.syncBackend.get('client').type,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    base: bindActionCreators(baseActions, dispatch),
    undo: bindActionCreators(undoActions, dispatch),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HeaderBar)
);
